import { MessageType, ReturnCode } from 'app/modules/remote-control-ng/definitions';
import { Observable, interval, Subscription, BehaviorSubject, Subject } from 'rxjs';

export class IdleTimerService {
  private interactionMessageTypes: number[] = [
    MessageType.PC_DOS_DIR,
    MessageType.PC_DOS_GET_FILE,
    MessageType.PC_DOS_GET_FILE_DATA,
    MessageType.PC_GETSYSINFO,
    MessageType.MOUSE,
    MessageType.KEYBOARD_CTRLED_ALTED_SEND,
    MessageType.PC_APPBUTTON,
    MessageType.KEYBOARD_POST,
    MessageType.KEYBOARD_SEND
  ];

  private timeoutLimit: number = 0;
  private messageSentEventClick: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private idleInteractionTimer: Subscription;
  private timeout: Subject<number> = new Subject<number>();
  public timeout$: Observable<number> = this.timeout.asObservable();

  public clearTimer() {
    if (this.idleInteractionTimer) {
      this.idleInteractionTimer.unsubscribe();
    }
  }

  private idleInteractionTimeout() {
    this.clearTimer();
    this.timeout.next(ReturnCode.PCR_TIMEOUT);
  }

  private restartIdleTimer() {
    this.clearTimer();
    if (this.timeoutLimit > 0) {
      this.idleInteractionTimer = interval(this.timeoutLimit).subscribe(() => {
        this.idleInteractionTimeout();
      });
    }
  }

  private checkIfUserInteractionMessage(messageType: number): boolean {
    return this.interactionMessageTypes.includes(messageType);
  }

  private convertMinutesToMilliseconds(minutes: number): number {
    return minutes * 60000;
  }

  clickEvent() {
    this.messageSentEventClick.next(MessageType.MOUSE);
  }

  getMessageSentEvent(): Observable<number> {
    return this.messageSentEventClick.asObservable();
  }

  init(timeoutMinutes: number) {
    if (timeoutMinutes > 0) {
      this.timeoutLimit = this.convertMinutesToMilliseconds(timeoutMinutes);
    }

    this.getMessageSentEvent().subscribe((messageType) => {
      const isUserInteraction = this.checkIfUserInteractionMessage(messageType);
      if (isUserInteraction) {
        this.restartIdleTimer();
      }
    });

    this.restartIdleTimer();
  }
}
